module.exports = __webpack_public_path__ + "static/media/ArrIcon.66f8bd1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/icons/ArrIcon.svg
// module id = 725
// module chunks = 0